import { render, staticRenderFns } from "./nobleriding.vue?vue&type=template&id=33e3b21d&scoped=true&"
import script from "./nobleriding.vue?vue&type=script&lang=js&"
export * from "./nobleriding.vue?vue&type=script&lang=js&"
import style0 from "./nobleriding.vue?vue&type=style&index=0&id=33e3b21d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e3b21d",
  null
  
)

/* custom blocks */
import block0 from "./nobleriding.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports